"use client";

import React from "react";
import { useI18nContext } from "@/context/i18n-context";

export default function Footer() {
  const { t } = useI18nContext();

  return (
    <footer className="w-full max-w-[52rem] pb-8 pt-6
      border-t border-[var(--color-border-subtle)]
      flex flex-col sm:flex-row items-center justify-between
      gap-2">
      <p className="text-xs text-[var(--color-text-tertiary)]">
        <span className="font-medium text-[var(--color-text-secondary)]">
          {t("footer.subtitle")}:
        </span>{" "}
        {t("footer.about")}
      </p>
      <p className="text-xs text-[var(--color-text-tertiary)]">
        &copy; {new Date().getFullYear()} Wangpeng An
      </p>
    </footer>
  );
}
